import mapboxgl from "mapbox-gl";
import React, { useEffect, useRef } from "react";
import "mapbox-gl/dist/mapbox-gl.css";
import styled from "styled-components";
import usePolygonMask from "./hooks/usePolygonMask";
import { showMapbounds } from "./utils/showMapbounds";

const Wrapper = styled.div`
  .mapboxgl-ctrl {
    display: none !important;
  }
`;

const StaticMap = ({ mapbounds }) => {
  const mapContainer = useRef(null);
  const map = useRef<mapboxgl.Map | null>(null);
  const [setPolygonMaskLayer, setPolygonMaskData] = usePolygonMask();

  useEffect(() => {
    if (!mapContainer.current) return;

    mapboxgl.accessToken = import.meta.env.VITE_MAPBOX_ACCESS_TOKEN;

    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/tmorino/claqq4d85005014ohjoqds4wt",
      interactive: false,
    });
    if (map.current) setPolygonMaskLayer(map.current);

    return () => {
      if (map.current) {
        map.current.remove();
      }
    };
  }, []);

  useEffect(() => {
    if (map.current && mapbounds) {
      map.current.on("load", () => {
        try {
          map.current?.addSource("geojson", {
            type: "geojson",
            data: mapbounds,
          });
        } catch (error) {
          console.log(error);
        }
        showMapbounds(map.current, mapbounds, true, setPolygonMaskData, 0);
      });

      // If the map is already loaded, trigger the code directly
      if (map.current?._loaded) {
        try {
          map.current.addSource("geojson", {
            type: "geojson",
            data: mapbounds,
          });
        } catch (error) {
          console.log(error);
        }
        showMapbounds(map.current, mapbounds, true, setPolygonMaskData, 0);
      }
    }
  }, []);

  return (
    <Wrapper
      ref={mapContainer}
      style={{
        width: "180px",
        height: "158px",
        backgroundColor: "transparent",
      }}
    />
  );
};

export default StaticMap;
